import React from "react";
import BreadCrumb from "../../components/common/breadCrumb";
import { useLocation,useParams } from "react-router-dom";
import SearchContentInput from "./search-content-input";
import { api } from "../../../config";
import { generatePopUpsDataByCatalog } from '../../utils';


const LogoBar = ({ icon, setOpenPopup, openPopup, popup, setPopup, selectedProduct}) => {
  const location = useLocation();

  const getRoute = location.pathname.split("/").filter((el) => el);
  let { marcaId, catalogoId, categoriaId } = useParams();

  const popups = Array.isArray(popup) ? popup : popup && generatePopUpsDataByCatalog(popup, catalogoId);


  return (
    <div className="info-bar">
      {marcaId && (
        <div className="logo">
          <img src={`${api.media.images}${marcaId}-logo`} />
        </div>
      )}
      <div className="bread">
        <BreadCrumb selectedProduct={selectedProduct}/>
        {getRoute[0] === "search" && getRoute.length === 1 ? (
          <div className="search-content">
            <SearchContentInput route={getRoute} />
          </div>
        ) : (
          ""
        )}
      </div>
      {(popups && popups[categoriaId && categoriaId.toLowerCase().replace(/\s/g, '-')] || popups && popups[marcaId && marcaId.toLowerCase().replace(/\s/g, '-')]  && getRoute[0] !== "search") && <div onClick={() => {return setPopup(popups && popups[categoriaId && categoriaId.toLowerCase().replace(/\s/g, '-')] || popups && popups[marcaId && marcaId.toLowerCase().replace(/\s/g, '-')] ), setOpenPopup(!openPopup)}} className="popUp"><img src="/assets/img/informacion.png"/></div>}

      {/* {(popup && (popup.category !== "" && !popup.category.name[categoriaId] && popup.brand !== "" && !popup.brand.name[marcaId]) && getRoute[0] !== "search") && <div onClick={() => setOpenPopup(!openPopup)} className="popUp"><img src="/assets/img/informacion.png"/></div>} */}
      {icon ? <div className="icon-option-list">icon</div> : ""}
    </div>
  );
};

export default LogoBar;
